import { putRequest } from "../httpMethods";

export const putTeacherProfile = (payload) =>
putRequest(`teachers/updateProfile`, payload);